// extracted by mini-css-extract-plugin
export default {"container":"CampaignsRoute_container__jMQw2","mainContainer":"CampaignsRoute_mainContainer__6hY6p"};